import React from "react"
import ReportTypes from "./Report_Types"

const ReportTypeSelection = (props) => {
  return <ReportTypes {...props} />
}
export default ReportTypeSelection
